import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Spin } from 'antd';
import LayoutComponent from './components/layout/LayoutComponent';
import LoginPage from './pages/LoginPage';
import MagicLinkPage from './pages/MagicLinkPage';
import AuthCallback from './pages/AuthCallbackPage';
import PublicRoute from './utils/PublicRoute';
import PrivateRoute from './utils/PrivateRoute';
import DashboardPage from './pages/DashboardPage';
import { Auth0Provider } from '@auth0/auth0-react';
import ResumeCreate from './pages/ResumeCreate';
import ResumeBuilderPage from './pages/ResumeBuilder'
import SavedJobs from './pages/SavedJobs';
import ResumesPage from './pages/ResumesPage';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import SettingsPage from './pages/SettingsPage';

function App() {
    return (
        <Suspense fallback={<Spin />}>
            <Auth0Provider
                domain="dev-c2i55la6he2dhh4d.us.auth0.com"
                clientId="LHsfRcOjiWOoPRKX5fTzA9T88zzs7leI"
                authorizationParams={{
                    audience: 'https://api.getingenie.com/auth/callback',
                    scope: 'openid profile email',
                    redirect_uri: `${window.location.origin}/auth/callback`
                }}
            >
                <LayoutComponent>
                    <Switch>
                        <PublicRoute path="/resume-builder/create" component={ResumeCreate} />
                        <PublicRoute path="/resume-builder/:resumeId/design" component={ResumeBuilderPage} />
                        <PublicRoute path="/resume-builder/:resumeId/improve" component={ResumeBuilderPage} />
                        <PublicRoute path="/resume-builder/:resumeId/:step" component={ResumeBuilderPage} />
                        <PublicRoute path="/resume-builder/:resumeId" component={ResumeBuilderPage} />
                        <PublicRoute path="/resume-builder" component={ResumeBuilderPage} />
                        <PublicRoute path="/auth" component={LoginPage} />
                        <PublicRoute path="/auth/callback" component={AuthCallback} />
                        <Route path="/magic-auth/:otpToken" component={MagicLinkPage} />
                        <PrivateRoute path="/search" exact component={DashboardPage} />
                        <PrivateRoute path="/jobs" exact component={SavedJobs} />
                        <PrivateRoute path="/settings" component={SettingsPage} />
                        <PrivateRoute path="/" component={ResumesPage} />
                        <Redirect from="/login" to="/auth" />
                        <Redirect to="/" />
                    </Switch>
                </LayoutComponent>
            </Auth0Provider>
        </Suspense>
    );
}

export default App;